module.exports = __webpack_public_path__ + "img/Feature.940d6b9e.jpg";